export const CATALOG_ITEM_TYPES = [
    {value: 'WallItem', label: 'Wall Item'},
    {value: 'FloorItem', label: 'Floor Item'},
    {value: 'Window', label: 'Window', deprecated: true},
    {value: 'Door', label: 'Door'},
    {value: 'Color', label: 'Color'},
    {value: 'Texture', label: 'Texture'},
    {value: 'WallPrint', label: 'Wall Print'},
    {value: 'Pillow', label: 'Pillow'},
    {value: 'Rug', label: 'Rug (flat)'},
    {value: 'Curtain', label: 'Curtain'},
    {value: 'Crib', label: 'Crib'},
    {value: 'ToddlerBed', label: 'Toddler Bed'},
    {value: 'TwinBed', label: 'Twin Bed'},
    {value: 'QueenBed', label: 'Queen Bed'},
    {value: 'Bassinet', label: 'Bassinet'},
    {value: 'Decal', label: 'Decal (not yet supported)'}
];
